import React from 'react';

import { DownstreamOwnerIdsFilteredByFieldQuery, DownstreamOwnerIdsFilteredByFieldQueryVariables, OwnerIdFragment, VirtualConnectionDownstreamOwnerIdsQuery, VirtualConnectionDownstreamOwnerIdsQueryVariables , DownstreamOwnerIdsFilteredByFieldDocument , VirtualConnectionDownstreamOwnerIdsDocument } from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  HorizontalFlexContainer,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { VirtualConnectionDownstreamOwnersQueryGrid } from './VirtualConnectionDownstreamOwnersQueryGrid';

export interface VirtualConnectionDownstreamOwnersPaneProps {
  readonly title: string;
  readonly vizportalUrlId: string;
  readonly filteredTableId: string | null;
  readonly rowCount: number | null;
  readonly virtualConnectionLuid: string;
}

export class VirtualConnectionDownstreamOwnersPane extends React.Component<VirtualConnectionDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.vizportalUrlId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              <HorizontalFlexContainer>
                {this.props.title}
                {this.props.rowCount != null && this.props.rowCount > 0 ?
                  <>
                    <MultiSelectionControls
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      updateSelectionForKey={updateSelectionForKey}
                      fetchAllKeys={this.fetchAllOwnerKeys}
                    />
                    <ComposeEmailPaneButton
                      selectedUserIds={selectedKeys}
                      contentType='virtualConnection'
                      contentId={this.props.vizportalUrlId}
                      contentLuid={this.props.virtualConnectionLuid}
                    />
                  </>
                  : null
                }
              </HorizontalFlexContainer>
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <VirtualConnectionDownstreamOwnersQueryGrid
                  vizportalUrlId={this.props.vizportalUrlId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredTableId={this.props.filteredTableId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredTableId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DownstreamOwnerIdsFilteredByFieldQueryVariables,
        DownstreamOwnerIdsFilteredByFieldQuery
      >({
        queryGql: DownstreamOwnerIdsFilteredByFieldDocument,
        selectConnectionListResult: (resultData) => {
          const field = resultData.fields && resultData.fields[0];
          return field.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { fieldId: this.props.filteredTableId }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        VirtualConnectionDownstreamOwnerIdsQueryVariables,
        VirtualConnectionDownstreamOwnerIdsQuery
      >({
        queryGql: VirtualConnectionDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const virtualConnection = resultData.virtualConnections && resultData.virtualConnections[0];
          return virtualConnection.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { vizportalUrlId: this.props.vizportalUrlId }, client);
    }
  }

}
